package com.fireavert.tenants.client

import com.fireavert.common.Try
import com.fireavert.logging.Logger
import com.fireavert.tenants.data_models.TenantModel
import com.fireavert.tenants.data_models.requests.CreateTenantRequest
import com.fireavert.tenants.data_models.requests.UpdateTenantRequest
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import io.ktor.http.*

class ClientTenantDataSource(
    private val httpClient: HttpClient,
    private val baseUrl: String,
    private val logger: Logger
) : TenantDataSource {

    override suspend fun getCurrentTenantForUnit(token: String, unitId: Int): Try<TenantModel?> {
        return Try.fromCoCallable {
            val response = httpClient.get {
                header("Authorization", "Bearer $token")
                url("$baseUrl/tenants/unit/$unitId/current")
            }
            if (response.status.isSuccess()) response.body()
            else throw ClientRequestException(response, "")
        }
    }

    override suspend fun getTenantsForUnit(token: String, unitId: Int): Try<List<TenantModel>> {
        return Try.fromCoCallable {
            val response = httpClient.get {
                header("Authorization", "Bearer $token")
                url("$baseUrl/tenants/unit/$unitId")
            }
            if (response.status.isSuccess()) response.body()
            else throw ClientRequestException(response, "")
        }
    }

    override suspend fun createTenant(token: String, request: CreateTenantRequest): Try<TenantModel> {
        return Try.fromCoCallable {
            val response = httpClient.post {
                header("Authorization", "Bearer $token")
                url("$baseUrl/tenants")
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            if (response.status.isSuccess()) response.body()
            else throw ClientRequestException(response, "")
        }
    }

    override suspend fun updateTenant(token: String, tenantId: Int, request: UpdateTenantRequest): Try<TenantModel> {
        return Try.fromCoCallable {
            val response = httpClient.put {
                header("Authorization", "Bearer $token")
                url("$baseUrl/tenants/$tenantId")
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            if (response.status.isSuccess()) response.body()
            else throw ClientRequestException(response, "")
        }
    }
}